import { useNavigate, Link } from 'react-router-dom'
import { ArrowLeft, Trophy } from 'lucide-react'
import SignalPerformanceDashboard from '@/components/Scanner/SignalPerformanceDashboard'

export default function ScannerGlobalDashboardPage() {
  const navigate = useNavigate()

  return (
    <div className="max-w-5xl mx-auto p-4 space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="btn-ghost p-2">
            <ArrowLeft size={20} />
          </button>
          <div>
            <h1 className="text-xl font-bold">Dashboard Global del Escáner</h1>
            <p className="text-sm text-slate-500 dark:text-gray-400">Rentabilidad agregada de todos los escáneres algorítmicos</p>
          </div>
        </div>
        <Link
          to="/scanner-algorithmic/rankings"
          className="btn-secondary flex items-center gap-2"
        >
          <Trophy size={16} />
          Rankings MC
        </Link>
      </div>

      <SignalPerformanceDashboard />
    </div>
  )
}
